import { Input, Select } from 'antd';

const { Option } = Select;

const PhoneInput = ({
    phone,
    setPhone,
    t,
    disabled,
    countryCode,
    setCountryCode,
}) => {

    // Get max length based on country code
    const getMaxLength = () => {
        switch (countryCode) {
            case '86':
                return 11; // China
            case '852':
                return 8; // Hong Kong
            default:
                return 11;
        }
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');

        if (countryCode === '86' && value.startsWith('86') && value.length > 11) {
            value = value.slice(2);
        } else if (countryCode === '852' && value.startsWith('852') && value.length > 8) {
            value = value.slice(3);
        }

        const maxLength = getMaxLength();
        value = value.slice(0, maxLength);

        setPhone(value);
    };

    const handleCountryChange = (value) => {
        setCountryCode(value);

        // Clear phone when changing country
        setPhone('');
    };

    return (
        <Input.Group compact>
            <Select
                disabled={!!disabled}
                value={countryCode}
                size="large"
                onChange={handleCountryChange}
                style={{ width: 90 }}
            >
                <Option value="86">+86</Option>
                <Option value="852">+852</Option>
            </Select>

            <Input
                style={{ width: 'calc(100% - 90px)' }}
                size="large"
                disabled={!!disabled}
                placeholder={t("text_enter_phone")}
                value={phone}
                maxLength={getMaxLength()}
                inputMode="numeric"
                onChange={handlePhoneChange}
            />
        </Input.Group>
    );
};

export default PhoneInput;